export const strNetworkFailed = 'Failed to fetch';
export const strNetworkUnavailable = 'NETWORK OR SERVER NOT AVAILABLE';
export const strDuplicateLogin = 'DUPLICATE LOGIN DISABLED';
export const strUserConnectFailed = 'USER CONNECT FAILED';
export const strUnableToConnectToV6 = 'Unable to connect to V6';
export const strInvalidClientToken = 'Invalid Client Session Token';
export const strServiceRestarting = 'Service restarting, please retry';
export const headerServiceRestarting = 'x-service-restarting';
export const strRequestTokenMismatch = "Request Token doesn't match user login state";
